module.exports = __webpack_public_path__ + "img/meditation_10--active.aab0e161.svg";